/**
 * Утилита для добавления cache-busting параметров к URL
 * Используется для принудительного обновления кэшированных файлов
 */

/**
 * Добавляет версионирование к URL для обхода кэша
 * @param url - оригинальный URL
 * @param version - версия (может быть buildId, timestamp или hash)
 * @returns URL с параметром версии
 */
export const addCacheBusting = (url: string, version?: string | number): string => {
  if (!url) return url;
  
  try {
    const urlObj = new URL(url);
    
    // Если версия не указана, используем timestamp
    const cacheBustValue = version 
      ? String(version) 
      : `v=${Date.now()}`;
    
    // Добавляем параметр версии
    urlObj.searchParams.set('v', cacheBustValue);
    
    return urlObj.toString();
  } catch (error) {
    // Если URL невалидный, добавляем параметр вручную
    const separator = url.includes('?') ? '&' : '?';
    const cacheBustValue = version ? String(version) : `v=${Date.now()}`;
    return `${url}${separator}v=${cacheBustValue}`;
  }
};

/**
 * Добавляет версионирование к массиву URL
 * @param urls - объект с URL
 * @param version - версия (может быть buildId, timestamp или hash)
 * @returns объект с URL с параметром версии
 */
export const addCacheBustingToUrls = <T extends Record<string, string>>(
  urls: T,
  version?: string | number
): T => {
  const result = {} as T;
  
  for (const key in urls) {
    if (Object.prototype.hasOwnProperty.call(urls, key)) {
      result[key] = addCacheBusting(urls[key], version) as T[Extract<keyof T, string>];
    }
  }
  
  return result;
};

